// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "cd1a2c1",
    "hash": "cd1a2c1",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "cd1a2c1",
    "semverString": null,
    "version": "2.1.1"
};
/* tslint:enable */
